"use strict";

var _defineProperty = require("/root/website/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/root/website/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tabs = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _context = require("./context");

var _core = require("@emotion/core");

var propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   The current index from active tab.
  */
  activeIndex: _propTypes.number,

  /**
   The display content of the tabs with the following components: `TabList`, `TabItem`, `TabsPanel` and `Tab`.
  */
  children: _propTypes.node.isRequired,

  /**
   The callback to be executed when tab is changed.
  */
  onTabChange: _propTypes.func
} : {};
var defaultProps = {
  activeIndex: 0,
  onTabChange: function onTabChange() {}
};

var Tabs = function Tabs(_ref) {
  var activeIndex = _ref.activeIndex,
      onTabChange = _ref.onTabChange,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["activeIndex", "onTabChange", "children"]);

  return (0, _core.jsx)(_context.TabsContext.Provider, {
    value: _objectSpread({
      activeIndex: activeIndex,
      onTabChange: onTabChange
    }, props)
  }, children);
};

exports.Tabs = Tabs;
process.env.NODE_ENV !== "production" ? Tabs.propTypes = propTypes : void 0;
Tabs.defaultProps = defaultProps;
Tabs.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tabs",
  "props": {
    "activeIndex": {
      "defaultValue": {
        "value": "0",
        "computed": false
      },
      "type": {
        "name": "number"
      },
      "required": false,
      "description": "The current index from active tab."
    },
    "onTabChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "The callback to be executed when tab is changed."
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": true,
      "description": "The display content of the tabs with the following components: `TabList`, `TabItem`, `TabsPanel` and `Tab`."
    }
  }
};